import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';
import groupList from '../../../Management/group/group.List.i18n'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import config from '@/config'

//restful api
import { auth } from '@/service'
import { temp as wsfinder } from '@/service/api/wsfinder'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1,
  totalRows: 0,
  cmd : "search",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
})

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Uploaded_at', sortable: true, thStyle: 'width: 12%' },
    { key: 'is_done', label: 'Status', sortable: true, thStyle: 'width: 12%' },
    { key: 'category', label: 'Category', sortable: true, thStyle: 'width: 15%' },
    { key: 'name', label: 'Filename', sortable: true },
    { key: 'source', label: 'Source', sortable: true, thStyle: 'width: 12%' },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '업로드 시간', sortable: true, thStyle: 'width: 12%' },
    { key: 'is_done', label: '상태', sortable: true, thStyle: 'width: 12%' },
    { key: 'category', label: '분류', sortable: true, thStyle: 'width: 15%' },
    { key: 'name', label: '파일 이름', sortable: true },
    { key: 'source', label: '출처', sortable: true, thStyle: 'width: 12%' },
  ]
}

export default {
  components: { DatePicker, vSelect, cSwitch, groupList, vueDropzone },
  name : "webshellRegist",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => {
    return {
      dropzoneOptions: {
          url: location.hostname == 'localhost' ? `${config.baseURL}/upload/wsfinder` : `${location.protocol}//${location.hostname.replace('manager', 'api')}/v1/upload/wsfinder`,
          thumbnailWidth: 150,
          maxFilesize: 20, // unit is
          addRemoveLinks: true,
          parallelUploads : 3,
          chunking : false,
          duplicateCheck : true,
          headers: {
            // 'ContentType' : 'application/json',
            'Authorization' : 'Bearer ' + auth.token
          },
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME"
      },
      dropzone : { bar_value: 0, count : 0, done : 0 },
      group_name :'',
      custom,
      codes,
      so : default_opt(),
      model : { total : 0, approved : 0, deleted : 0, waiting : 0 },
      sync : { interval : 15, stop : false, th : undefined },
      id_list : [],
      nbsp: "\u00A0",
      hide_del: true,
      count: 0,
    }
  },
  computed: {
    fields : function() {
      return i18n_fields[this.i18n];
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    // start dropzone function
    processing() { return this.$refs.dropzone.processQueue(); },
    clear() {
      this.$refs.dropzone.removeAllFiles();
      this.refresh();
    },
    noti_add(rs) { console.log(rs.name, "loading"); this.dropzone.count += 1; },
    noti_error(rs) { this.$toastr.w(rs.name, "duplicate"); console.log("error : ", rs); this.dropzone.done +=1 },
    noti_progress(rs){ console.log("status : ", rs); this.dropzone.bar_value = rs; },
    noti_upload_item(rs) { this.$toastr.i(rs.name, rs.status); this.$refs.dropzone.removeFile(rs); this.dropzone.done +=1; },
    noti_upload_all() {
      this.$toastr.s("processing", "completed")
      this.refresh();
    },
    async regist_all() {
      if(!this.id_list.length) { return this.$toastr.w("no have data", this.$route.name) }
      wsfinder.applyTemp(this.id_list)
        .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } else { this.$toastr.s("completed", this.$route.name); } this.refresh(); })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    async delete_all() {
      if(!this.id_list.length) { return this.$toastr.w("no have data", this.$route.name) }
      wsfinder.delTemp(this.id_list )
        .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } else { this.$toastr.s("completed", this.$route.name); } this.refresh(); })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.refresh(); },
    refresh() {
      console.log('refresh'); this.$refs._list.refresh();
      this.dropzone.bar_value = 0;
      this.dropzone.count = 0;
      this.dropzone.done = 0;
    },
    getItems: function(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'type':
              cond = this.set_op(k[i], this.codes.code_type_key[this.so.opt[k[i]]], true);
              break;
            case 'category':
              cond = this.set_op(k[i], this.codes.code_category_key[this.so.opt[k[i]]], true);
              break;
            case 'ext':
              cond = this.set_op(k[i], this.codes.code_ext_key[this.so.opt[k[i]]], true);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if( cond.value == '-' || cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
        return wsfinder.listTemp(so).then(rs => {
        this.so.totalRows = rs.total;
        this.id_list = [];

        if (rs.body && rs.body.length) {
          for (let index = 0; index < rs.body.length; index++) { this.id_list.push(rs.body[index].id); }
        }

        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) {
      this.$router.push({ name : 'wsfinder_regist', params : { id: item.id } })
    },
    summary() {
      let and = [];
      wsfinder.summaryTemp({ and : and, or : [], sort : [] })
        .then(rs => { 
          if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } 
          else { this.model = Object.assign(this.model, { total : rs.body.total, deleted : rs.body.disable, approved : rs.body.approved, waiting : (rs.body.total - rs.body.disable) - rs.body.approved }) } 
        }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    }
  },
  watch: { '$route' (to, from) { this.$on('refresh', this.refresh()) } },
  created: function() { console.log('upattern.list.vue', 'created'); },
  destroyed: function() { console.log('upattern.list.vue', 'destroyed'); },
  mounted: function() {
    console.log('upattern.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}